import { ISlaPolicy } from './client';
import { SlaPolicyServer } from './server';

export const normalizeSlaPolicy = (raw: SlaPolicyServer): ISlaPolicy => {
  return {
    enabled: raw.enabled,
    firstResponseMinutes: raw.first_response_minutes,
    responseMinutes: raw.response_minutes,
    sortAvailable: raw.sort_available
  };
};
